import React from 'react';
import styles from './HeaderHero.module.css';

type HeaderHeroProps = {
  title?: string;
  subtitle?: string;
  imageSrc?: string;
  imageAlt?: string;
};

const heroFacts = [
  'Фокусируемся на результате',
  'Современный дизайн',
  'Быстрый запуск проекта',
];

const HeaderHero: React.FC<HeaderHeroProps> = ({
  title = 'РАЗРАБОТКА ВЕБ САЙТОВ',
  subtitle = 'Создаем сайты любой сложности. Современный дизайн. Быстрая разработка. Полный цикл.',
  imageSrc = '/images/hero-bg.jpg',
  imageAlt = 'Фоновое изображение',
}) => (
  <section className={styles.hero}>
    <img
      src={imageSrc}
      alt={imageAlt}
      className={styles.heroImage}
      loading="lazy"
    />

    <div className={styles.tintLayer} aria-hidden="true" />
    <div className={styles.highlight} aria-hidden="true" />
    <div className={styles.lightBloom} aria-hidden="true" />

    <div className={styles.heroContent}>
      <span className={styles.eyebrow}>SkyWard</span>
      <h1 className={styles.heroTitle}>{title}</h1>
      <p className={styles.heroSubtitle}>{subtitle}</p>

      <div className={styles.facts}>
        {heroFacts.map((fact) => (
          <div key={fact} className={styles.fact}>
            {fact}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default HeaderHero;
